import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

enum CodeRequestTypes {
  sms = 'sms',
  voice = 'voice',
}

export interface CodeRequest {
  type: CodeRequestTypes;
  recaptchaToken: string;
}

export default (makeCall: MakeCall) => (
  userId: number,
  { type, recaptchaToken }: CodeRequest,
) =>
  makeCall('POST', `${APIV2_URL}/user/${userId}/request-code`, {
    data: {
      type,
      recaptchaToken,
    },
  });
